'use strict';/* global define:false */define('helen/ui/autofocus',[],function(){'use strict';function directive(){return{restrict:'A',link:function link(scope,element){element[0].focus();}};}return directive;});
